import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useTheme, alpha } from "@mui/material/styles";

const UnitConversionDialog = ({ open, onClose, onApply, rows = [] }) => {
  const [localRows, setLocalRows] = React.useState([]);

  const { t } = useTranslation();
  const theme = useTheme();

  React.useEffect(() => {
    if (open) {
      setLocalRows(rows);
    }
  }, [open, rows]);

  const columns = [
    {
      field: "itemNfe",
      headerName: t("assing.item"),
      width: 100,
    },
    {
      field: "materialNfe",
      headerName: t("assing.materialXml"),
      width: 150,
    },
    {
      field: "shortText",
      headerName: t("assing.descMaterialXml"),
      width: 220,
    },
    {
      field: "uom",
      headerName: t("assing.unit"),
      width: 150,
    },
    {
      field: "erpMaterial",
      headerName: t("assing.materialErp"),
      width: 150,
    },
    {
      field: "shortTextErp",
      headerName: t("assing.descMaterialErp"),
      width: 220,
    },
    {
      field: "convertedUom",
      headerName: t("assing.unitErp"),
      width: 150,
      editable: true,
      cellClassName: "editable-cell",
    },
  ];

  const handleProcessRowUpdate = (newRow) => {
    const updatedRows = localRows.map((row) =>
      String(row.id) === String(newRow.id) ? newRow : row,
    );

    setLocalRows(updatedRows);
    return newRow;
  };

  const handleApply = () => {
    onApply?.(localRows);
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <DialogTitle>
        <Typography variant="h6" sx={{ fontWeight: 800, color: "text.primary" }}>
          {t("assing.unitMeasurementConversion")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <div style={{ height: 360, width: "100%", marginTop: 8 }}>
          <DataGrid
            rows={localRows}
            columns={columns}
            density="compact"
            hideFooter
            disableRowSelectionOnClick
            processRowUpdate={handleProcessRowUpdate}
            sx={{
              border: 0,
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "background.subtle",
                borderBottom: "2px solid",
                borderColor: "divider",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: 700,
                fontSize: "0.7rem",
                color: "text.secondary",
                textTransform: "uppercase",
              },
              "& .editable-cell": {
                backgroundColor: alpha(theme.palette.primary.main, 0.12),
              },
            }}
          />
        </div>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          {t("buttons.bClose")}
        </Button>
        <Button
          variant="contained"
          onClick={handleApply}
          sx={{ textTransform: "none", px: 3 }}
        >
          {t("buttons.bSave")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnitConversionDialog;